var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v(" ")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "", id: "sidebarMenuClose" } },
              [
                _c("feather", {
                  staticClass:
                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                  attrs: { type: "x" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-body" }, [
            _vm.properties.uid
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "has-text-weight-semibold",
                                  attrs: { for: form.id }
                                },
                                [
                                  _vm._v(_vm._s(form.name) + " "),
                                  form.division === "C" && form.attr
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tx-danger has-text-weight-semibold"
                                        },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.platingData[form.id],
                                    expression: "platingData[form.id]",
                                    modifiers: { lazy: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "email",
                                  name: form.id,
                                  id: form.id,
                                  placeholder: form.name
                                },
                                domProps: { value: _vm.platingData[form.id] },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.platingData,
                                      form.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        : form.division === "O"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "d-block has-text-weight-semibold",
                                  attrs: { for: "formGroupExampleInput" }
                                },
                                [_vm._v(_vm._s(form.name))]
                              ),
                              _vm._v(" "),
                              form.value.length > 0
                                ? _c(
                                    "p",
                                    { staticClass: "mg-b-0 text-left" },
                                    _vm._l(form.value, function(form1, i) {
                                      return form1.codeCode ==
                                        _vm.platingData[form.id]
                                        ? _c("span", [
                                            _vm._v(_vm._s(form1.codeName))
                                          ])
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                : _c("p", { staticClass: "mg-b-0 text-left" }, [
                                    _vm._v(_vm._s(_vm.platingData[form.id]))
                                  ])
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.checkboxSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  " d-block has-text-weight-semibold",
                                attrs: { for: "formGroupExampleInput" }
                              },
                              [
                                _vm._v(_vm._s(form.name) + " "),
                                form.division === "C" && form.attr
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "tx-danger has-text-weight-semibold"
                                      },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(form.value, function(form1, i) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "ml-2 custom-control custom-radio mb-1"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.platingData[form.id],
                                        expression: "platingData[form.id]"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: form1.codeCode,
                                      name: form.id
                                    },
                                    domProps: {
                                      value: form1.codeCode,
                                      checked:
                                        form1.codeCode ==
                                        _vm.platingData[form.id],
                                      checked: _vm._q(
                                        _vm.platingData[form.id],
                                        form1.codeCode
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.platingData,
                                          form.id,
                                          form1.codeCode
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: form1.codeCode }
                                    },
                                    [_vm._v(_vm._s(form1.codeName))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dateSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "d-block has-text-weight-semibold",
                              attrs: { for: "formGroupExampleInput" }
                            },
                            [
                              _vm._v(_vm._s(form.name) + " "),
                              form.division === "C" && form.attr
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "tx-danger has-text-weight-semibold"
                                    },
                                    [_vm._v("*")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "mg-b-0 text-left" }, [
                            _vm._v(_vm._s(_vm.platingData[form.id]))
                          ])
                        ])
                      ])
                    })
                  ],
                  2
                )
              : _c(
                  "div",
                  [
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "has-text-weight-semibold",
                                  attrs: { for: form.id }
                                },
                                [
                                  _vm._v(_vm._s(form.name) + " "),
                                  form.division === "C" && form.attr
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tx-danger has-text-weight-semibold"
                                        },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.platingData[form.id],
                                    expression: "platingData[form.id]",
                                    modifiers: { lazy: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "email",
                                  name: form.id,
                                  id: form.id,
                                  placeholder: form.name
                                },
                                domProps: { value: _vm.platingData[form.id] },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.platingData,
                                      form.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        : form.division === "O"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "d-block has-text-weight-semibold",
                                  attrs: { for: "formGroupExampleInput" }
                                },
                                [_vm._v(_vm._s(form.name))]
                              ),
                              _vm._v(" "),
                              form.value.length > 0
                                ? _c(
                                    "p",
                                    { staticClass: "mg-b-0 text-left" },
                                    _vm._l(form.value, function(form1, i) {
                                      return form1.codeCode ==
                                        _vm.platingData[form.id]
                                        ? _c("span", [
                                            _vm._v(_vm._s(form1.codeName))
                                          ])
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                : _c("p", { staticClass: "mg-b-0 text-left" }, [
                                    _vm._v(_vm._s(_vm.platingData[form.id]))
                                  ])
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.checkboxSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  " d-block has-text-weight-semibold",
                                attrs: { for: "formGroupExampleInput" }
                              },
                              [
                                _vm._v(_vm._s(form.name) + " "),
                                form.division === "C" && form.attr
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "tx-danger has-text-weight-semibold"
                                      },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(form.value, function(form1, i) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "ml-2 custom-control custom-radio mb-1"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.platingData[form.id],
                                        expression: "platingData[form.id]"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: form1.codeCode,
                                      name: form.id
                                    },
                                    domProps: {
                                      value: form1.codeCode,
                                      checked:
                                        form1.codeCode ==
                                        _vm.platingData[form.id],
                                      checked: _vm._q(
                                        _vm.platingData[form.id],
                                        form1.codeCode
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.platingData,
                                          form.id,
                                          form1.codeCode
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: form1.codeCode }
                                    },
                                    [_vm._v(_vm._s(form1.codeName))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dateSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "has-text-weight-semibold",
                                    attrs: { for: form.id }
                                  },
                                  [
                                    _vm._v(_vm._s(form.name) + " "),
                                    form.division === "C" && form.attr
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tx-danger has-text-weight-semibold"
                                          },
                                          [_vm._v("*")]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("date-picker", {
                                  staticClass: "form-control",
                                  attrs: {
                                    config: _vm.datePickerOptions,
                                    autocomplete: "off",
                                    placeholder: form.name,
                                    id: form.id,
                                    "aria-label": "Search",
                                    ignoreReadonly: ""
                                  },
                                  model: {
                                    value: _vm.platingData[form.id],
                                    callback: function($$v) {
                                      _vm.$set(_vm.platingData, form.id, $$v)
                                    },
                                    expression: "platingData[form.id]"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    })
                  ],
                  2
                )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content content-components pd-b-0-f overflow-hidden" },
        [
          _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-sm-flex align-items-center justify-content-between"
              },
              [
                _c("div", [
                  _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                    _c(
                      "ol",
                      { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                      [
                        _c("li", { staticClass: "breadcrumb-item" }, [
                          _vm._v(_vm._s(this.mainName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "breadcrumb-item",
                            attrs: { "aria-current": "page" }
                          },
                          [_vm._v(_vm._s(this.subName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "breadcrumb-item active",
                            attrs: { "aria-current": "page" }
                          },
                          [_vm._v("Detail")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                      _vm._v(_vm._s(this.subName) + " Detail")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                  },
                  [
                    _vm.appButtonFlag
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                            on: {
                              click: function($event) {
                                return _vm.confirmData()
                              }
                            }
                          },
                          [
                            _c("feather", {
                              staticClass:
                                "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                              attrs: { type: "folder" }
                            }),
                            _vm._v("Confirm")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                        on: {
                          click: function($event) {
                            return _vm.createData(true, "create")
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "folder" }
                        }),
                        _vm._v("Save")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.properties.uid
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                            on: {
                              click: function($event) {
                                return _vm.deleteData()
                              }
                            }
                          },
                          [
                            _c("feather", {
                              staticClass:
                                "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                              attrs: { type: "delete" }
                            }),
                            _vm._v("delete")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                        attrs: {
                          href: "#modal1",
                          "data-toggle": "modal",
                          "data-animation": "effect-flip-horizontal"
                        },
                        on: { click: function($event) {} }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "file" }
                        }),
                        _vm._v("SAMPLESHEET")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                        on: {
                          click: function($event) {
                            return _vm.goPage()
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "file" }
                        }),
                        _vm._v("List")
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: " pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
              _c("div", { staticClass: "col-sm-6 col-lg-5 d-inline-block" }, [
                _c(
                  "ul",
                  {
                    staticClass: "cardborder nav nav-tabs",
                    attrs: { id: "myTab", role: "tablist" }
                  },
                  [
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link active",
                          attrs: {
                            id: "plating-tab",
                            "data-toggle": "tab",
                            href: "#plating",
                            role: "tab",
                            "aria-controls": "plating",
                            "aria-selected": "true"
                          },
                          on: { click: this.rendertab }
                        },
                        [_vm._v("Plating")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(0)
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card card-body pd-b-0-f" }, [
                _c(
                  "div",
                  { staticClass: "tab-content", attrs: { id: "myTabContent" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tab-pane fade lm-overflow show active",
                        attrs: {
                          id: "plating",
                          role: "tabpanel",
                          "aria-labelledby": "plating-tab"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-none d-md-block tx-right-f mg-xs-y-15-f"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-animation": "effect-flip-horizontal"
                                },
                                on: { click: this.checkAll }
                              },
                              [
                                _c("feather", {
                                  staticClass:
                                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                  attrs: { type: "check" }
                                }),
                                _vm._v("all checked")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-animation": "effect-flip-horizontal"
                                },
                                on: { click: this.sampleDelColumn }
                              },
                              [
                                _c("feather", {
                                  staticClass:
                                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                  attrs: { type: "minus" }
                                }),
                                _vm._v("delete")
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-line",
                            attrs: { id: "myTab5", role: "tablist" }
                          },
                          _vm._l(_vm.tabHeader, function(form, i) {
                            return _vm.properties.mid === form.id
                              ? _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link active",
                                      attrs: {
                                        id: form.id,
                                        "data-toggle": "tab",
                                        href: "#",
                                        role: "tab",
                                        "aria-controls": "home",
                                        "aria-selected": "true"
                                      },
                                      on: { click: _vm.classifySampleHeader }
                                    },
                                    [_vm._v(_vm._s(form.menuName))]
                                  )
                                ])
                              : _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        id: form.id,
                                        "data-toggle": "tab",
                                        href: "#",
                                        role: "tab",
                                        "aria-controls": "profile",
                                        "aria-selected": "false"
                                      },
                                      on: { click: _vm.classifySampleHeader }
                                    },
                                    [_vm._v(_vm._s(form.menuName))]
                                  )
                                ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("hot-table", {
                          ref: "sheet",
                          staticClass: "ht-hot-table zero-index",
                          attrs: {
                            id: "sample-table",
                            settings: _vm.sheetSettings,
                            data: _vm.sampleData,
                            afterChange: _vm.changeData
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "tab-pane fade",
                        attrs: {
                          id: "samples",
                          role: "tabpanel",
                          "aria-labelledby": "samples-tab"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-none d-md-block tx-right-f mg-xs-y-15-f"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-animation": "effect-flip-horizontal"
                                },
                                on: { click: _vm.sampleAddColumn }
                              },
                              [
                                _c("feather", {
                                  staticClass:
                                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                  attrs: { type: "plus" }
                                }),
                                _vm._v("Add")
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-line",
                            attrs: { id: "myTab5", role: "tablist" }
                          },
                          _vm._l(_vm.tabHeader, function(form, i) {
                            return _vm.tabHeader.length - 2 === i
                              ? _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link active",
                                      attrs: {
                                        id: form.id,
                                        "data-toggle": "tab",
                                        href: "#",
                                        role: "tab",
                                        "aria-controls": "home",
                                        "aria-selected": "true"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.classifyWorkChange(form.id)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(form.menuName))]
                                  )
                                ])
                              : _vm._e()
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "section",
                          [
                            _c(
                              "b-table",
                              {
                                ref: "table",
                                attrs: {
                                  id: "preTable",
                                  data: _vm.isEmpty ? [] : _vm.preData,
                                  "checked-rows": _vm.checkedRows,
                                  striped: "",
                                  checkable: "",
                                  detailed: "",
                                  "detail-key": "id",
                                  "show-detail-icon": false,
                                  "opened-detailed": _vm.defaultOpenedDetails
                                },
                                on: {
                                  "update:checkedRows": function($event) {
                                    _vm.checkedRows = $event
                                  },
                                  "update:checked-rows": function($event) {
                                    _vm.checkedRows = $event
                                  },
                                  "details-open": function(row, index) {
                                    return _vm.closeAllOtherToggle(row, index)
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(props) {
                                      return _vm._l(_vm.preHeader, function(
                                        form,
                                        i
                                      ) {
                                        return Number(i) == 0
                                          ? _c(
                                              "b-table-column",
                                              {
                                                key: form.id,
                                                attrs: {
                                                  "custom-key": form.id,
                                                  field: "no",
                                                  label: "No",
                                                  centered: ""
                                                }
                                              },
                                              [_vm._v(_vm._s(props.row.no))]
                                            )
                                          : Number(i) == 1
                                          ? _c(
                                              "b-table-column",
                                              {
                                                key: form.id,
                                                attrs: {
                                                  "custom-key": form.id,
                                                  field: form.columnCode,
                                                  label: form.columnName,
                                                  centered: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "#",
                                                      id: props.index
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggle(
                                                          props.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          props.row[
                                                            form.columnCode
                                                          ]
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "b-table-column",
                                              {
                                                key: form.id,
                                                attrs: {
                                                  "custom-key": form.id,
                                                  field: form.columnCode,
                                                  label: form.columnName,
                                                  centered: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    props.row[form.columnCode]
                                                  )
                                                )
                                              ]
                                            )
                                      })
                                    }
                                  },
                                  {
                                    key: "detail",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "ul",
                                          {
                                            staticClass: "nav nav-line",
                                            attrs: {
                                              id: "myTab5",
                                              role: "tablist"
                                            }
                                          },
                                          _vm._l(_vm.tabHeader, function(
                                            form,
                                            i
                                          ) {
                                            return form.id == _vm.re_expid
                                              ? _c(
                                                  "li",
                                                  { staticClass: "nav-item" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "nav-link active",
                                                        attrs: {
                                                          id: form.id,
                                                          "data-toggle": "tab",
                                                          href: "#",
                                                          role: "tab",
                                                          "aria-controls":
                                                            "home",
                                                          "aria-selected":
                                                            "true"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.classifyPreSampleHeader
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(form.menuName)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm.re_expid.length == 0 &&
                                                i == _vm.tabHeader.length - 2
                                              ? _c(
                                                  "li",
                                                  { staticClass: "nav-item" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "nav-link active",
                                                        attrs: {
                                                          id: form.id,
                                                          "data-toggle": "tab",
                                                          href: "#",
                                                          role: "tab",
                                                          "aria-controls":
                                                            "home",
                                                          "aria-selected":
                                                            "false"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.classifyPreSampleHeader
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(form.menuName)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm.tabHeader.length - 2 >= i
                                              ? _c(
                                                  "li",
                                                  { staticClass: "nav-item" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "nav-link",
                                                        attrs: {
                                                          id: form.id,
                                                          "data-toggle": "tab",
                                                          href: "#",
                                                          role: "tab",
                                                          "aria-controls":
                                                            "home",
                                                          "aria-selected":
                                                            "false"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.classifyPreSampleHeader
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(form.menuName)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          }),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c("b-table", {
                                          ref: "sampleTable",
                                          attrs: {
                                            id: "preSampleTable",
                                            columns: _vm.preSampleHeader,
                                            data: _vm.isEmpty
                                              ? []
                                              : _vm.preSampleData,
                                            "checked-rows":
                                              _vm.sampleCheckedRows,
                                            hoverable: "",
                                            striped: "",
                                            checkable: ""
                                          },
                                          on: {
                                            "update:checkedRows": function(
                                              $event
                                            ) {
                                              _vm.sampleCheckedRows = $event
                                            },
                                            "update:checked-rows": function(
                                              $event
                                            ) {
                                              _vm.sampleCheckedRows = $event
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              },
                              [
                                _vm._v(" "),
                                _c("template", { slot: "empty" }, [
                                  _c("section", { staticClass: "section" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "content has-text-grey has-text-centered"
                                      },
                                      [_c("p", [_vm._v("Nothing here.")])]
                                    )
                                  ])
                                ])
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-none" },
                              [
                                _c("b-table", {
                                  ref: "sampleTable",
                                  attrs: { id: "preSampleTable" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal5",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel5",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          staticStyle: { "background-color": "rgba(0, 0, 0, 0.4)" },
          attrs: {
            id: "modal1",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "limitModal",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              staticStyle: { "max-width": "570px" },
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row row-xs mt-1 d-block" }, [
                    _c(
                      "div",
                      { staticClass: "list-group" },
                      [
                        _c("h6", { staticClass: "is-pulled-left" }, [
                          _vm._v("• Version")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-field",
                          { attrs: { type: _vm.chkType, message: _vm.chkMsg } },
                          [
                            _c(
                              "b-select",
                              {
                                attrs: {
                                  placeholder: "Select a character",
                                  expanded: ""
                                },
                                model: {
                                  value: _vm.selectedOptions,
                                  callback: function($$v) {
                                    _vm.selectedOptions = $$v
                                  },
                                  expression: "selectedOptions"
                                }
                              },
                              [
                                _c("option", { attrs: { value: "Original" } }, [
                                  _vm._v("Original")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "LRM" } }, [
                                  _vm._v("LRM")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary tx-13",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.csvExport(_vm.selectedOptions)
                        }
                      }
                    },
                    [_vm._v("EXPORT")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass: "nav-link",
          attrs: {
            id: "samples-tab",
            "data-toggle": "tab",
            href: "#samples",
            role: "tab",
            "aria-controls": "samples",
            "aria-selected": "false"
          }
        },
        [_vm._v("Samples")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel5" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h6", { staticClass: "modal-title", attrs: { id: "limitModal" } }, [
        _vm._v("DOWNLOAD")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-226426d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226426d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Sequencing/Plating/DetailForm.vue
// module id = null
// module chunks = 